var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Button',{attrs:{"type":"success","outlined":true,"loading":_vm.loading,"disabled":_vm.disabled,"icon":"icon-check","title":_vm.$t('invite.accept')},on:{"click":function($event){return _vm.$emit('click')}}})}
var staticRenderFns = []

export { render, staticRenderFns }